export const DEALER_SERVICE = "DealerService";
